import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'
import accessGroups from 'modules/core/store/collections/accessGroups'
import type AccessGroup from 'modules/core/store/models/AccessGroup'

const Names = {
  target: 'target',
  peers: 'peers',
}

interface IGroup {
  [key: string]: any
}

class Group extends Model<IGroup> {
  static urlRoot() {
    return '/surveys/groups'
  }

  static Names = Names

  constructor(attr: IGroup = {}) {
    super(attr)
    makeObservable(this, {
      accessGroup: computed,
    })
  }

  get indexes() {
    return ['name', 'access_group_id']
  }

  get accessGroup(): AccessGroup | null | undefined {
    return accessGroups.find({
      id: this.attributes.access_group_id,
    })
  }
}

export default Group
